module.exports = __webpack_public_path__ + "static/images/containers/WGCWXLeaderboards/images/light_right.0435424e.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXLeaderboards/images/light_right.png
// module id = 3480
// module chunks = 11